<button class="export-button" mat-stroked-button color="primary" aria-label="Open export transactions menu" [matMenuTriggerFor]="exportMenu" [disabled]="isDisabled ||( isExporting$ | async)">
  <mat-icon class="notranslate">launch</mat-icon>
  Export
  <terra-loader *ngIf="isExporting$ | async"></terra-loader>
</button>

<mat-menu #exportMenu="matMenu" xPosition="before">
  <button mat-menu-item (click)="exportTransactions('excel')">
    Export to Excel
  </button>
  <button mat-menu-item (click)="exportTransactions('csv')">
    Export to CSV
  </button>
</mat-menu>
